import {
  type ComponentProps,
  type CSSProperties,
  type FC,
  PropsWithChildren,
  useState,
} from 'react';
import ReactDraggable from 'react-draggable';
import styled from '@emotion/styled';
import { borderRadii, layers } from 'app/spacing';
import { css } from '@emotion/core';

const Wrapper = styled.div<{ dragging: boolean }>`
  position: relative;
  ${({ dragging }) =>
    dragging &&
    css`
      z-index: ${layers.content(0, 1)};
      pointer-events: none; // TODO this makes the cursor change back to normal but allows mouseover
    `}
`;

const StyledPlaceholder = styled.svg`
  overflow: hidden;
  border-radius: ${borderRadii.standard};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;

export const Placeholder: FC<
  PropsWithChildren<{ dragging: boolean; style?: CSSProperties }>
> = ({ dragging, style, children }) => (
  <Wrapper dragging={dragging} style={style}>
    <StyledPlaceholder
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="100%"
        height="100%"
        fill="var(--color-background-light)"
        rx={borderRadii.standard}
        ry={borderRadii.standard}
        stroke="var(--color-border-medium)"
        strokeWidth="2"
        strokeDasharray="3,8"
        strokeLinecap="square"
      />
    </StyledPlaceholder>
    {children}
  </Wrapper>
);

export default function Draggable({
  position,
  onStart,
  onStop,
  style,
  ...props
}: ComponentProps<typeof ReactDraggable> & { style?: CSSProperties }) {
  const [dragging, setDragging] = useState(false);
  return (
    <Placeholder dragging={dragging} style={style}>
      <ReactDraggable
        handle=".Handle"
        position={{ x: 0, y: 0 }}
        onStart={(ev, data) => {
          setDragging(true);
          if (onStart) onStart(ev, data);
        }}
        onStop={(ev, data) => {
          setDragging(false);
          if (onStop) onStop(ev, data);
        }}
        {...props}
      />
    </Placeholder>
  );
}
